import useFieldValidation from 'hooks/useFieldValidation';
function useColorValidation(form, t) {
    return useFieldValidation(['colorName'], () => { var _a; return (!((_a = form.colorName) === null || _a === void 0 ? void 0 : _a.trim()) ? t('specification:required_field') : null); }, () => t('specification:color_name'));
}
export default useColorValidation;
